import { useMutation } from 'react-query'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { postTransactions } from 'services/easyPay'
import posthog from 'posthog-js'

export default function useSetTransactions() {
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ITransactionPayload) => {
            return postTransactions(payload)
        },
        onSuccess: (result, variables) => {
            posthog.capture('payment_gateway_redirect', {
                flow_type: 'group_all_payment',
                amount: variables?.amount,
                gateway: variables?.gateway,
                ctx_type: variables?.ctx_type,
                transaction_pk: (result as any)?.pk,
            })
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'group-all-payment',
                    data: state.toBePaidTransactions,
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            //@ts-ignore
            window.location.replace(result?.pay_url)
        },
        onError: () => {
            posthog.capture('payment_initiate_failed', {
                flow_type: 'group_all_payment',
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
